import { render, staticRenderFns } from "./RecordDueAtReminderNotification.vue?vue&type=template&id=61e3e4c1&scoped=true&"
import script from "./RecordDueAtReminderNotification.vue?vue&type=script&lang=js&"
export * from "./RecordDueAtReminderNotification.vue?vue&type=script&lang=js&"
import style0 from "./RecordDueAtReminderNotification.vue?vue&type=style&index=0&id=61e3e4c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3e4c1",
  null
  
)

export default component.exports